import { makeStyles } from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import { useEffect, useState } from "react";
import { Button } from "react-admin";
import { useField, useFormState } from "react-final-form";

interface IAddRouteButton {
  isOpenNewRoutePanel: boolean;
  handleOpenRoutePanel: (x: boolean) => void;
}

const useStyles = makeStyles({
  addRouteButton: {
    width: "100%",
    marginLeft: 0,
    borderRadius: 0,
    padding: 15,
    backgroundColor: "#E7E7E7",
    color: "#4E4E4E",
    fontWeight: 600,
    boxShadow: "unset",
    "&:hover": {
      backgroundColor: "#D8D8D8 !important",
    },
  },
});

const AddRouteButton = ({
  handleOpenRoutePanel,
  isOpenNewRoutePanel,
}: IAddRouteButton) => {
  const [isDisable, setIsDisable] = useState<boolean>(true);

  const classes = useStyles();
  const { values } = useFormState();
  const routeNameField = useField("route.name");
  const routeBusBayNumberField = useField("route.busBayNumber");
  const routeStartTimeField = useField("route.startTime");
  const routeEndTimeField = useField("route.endTime");
  const routeDriverIdField = useField("route.driverId");
  const routeBusAssistantIdField = useField("route.busAssistantId");
  const routeVehicleIdField = useField("route.vehicleId");
  const routeLocationsField = useField("route.routeLocations");
  const routeBackupDriversField = useField("route.backupDriverIds");
  const routeBackupVehiclesField = useField("route.backupVehicleIds");
  const routeBackupBusAssistantsField = useField("route.backupBusAssistantIds");

  //for subcontractor payment
  const routeAssignedSubcontractorField = useField(
    "route.assignedSubcontractor"
  );

  useEffect(() => {
    if (
      values?.busScheduleId
      // && values?.nextEffectiveDate
    ) {
      setIsDisable(false);
    } else {
      setIsDisable(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  useEffect(() => {
    if (isOpenNewRoutePanel) {
      routeNameField.input.onChange("");
      routeBusBayNumberField.input.onChange("");
      routeStartTimeField.input.onChange("");
      routeEndTimeField.input.onChange("");
      routeDriverIdField.input.onChange("");
      routeBusAssistantIdField.input.onChange("");
      routeVehicleIdField.input.onChange("");
      routeLocationsField.input.onChange("");
      routeBackupDriversField.input.onChange("");
      routeBackupVehiclesField.input.onChange("");
      routeBackupBusAssistantsField.input.onChange("");
      routeAssignedSubcontractorField.input.onChange("");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenNewRoutePanel]);

  return (
    <Button
      label="Add Route"
      alignIcon="right"
      className={classes.addRouteButton}
      onClick={() => handleOpenRoutePanel(false)}
      disabled={isDisable}
    >
      <AddCircleOutlineIcon />
    </Button>
  );
};

export default AddRouteButton;
